import React, { Component } from 'react'
import './Customers.css'

let companies = []
class Customers extends Component {

    componentWillReceiveProps(incomingData) {
        companies = incomingData.topCompanies.company_details
        if(!companies){
            companies=[]
        }
    }
    
    render() {
       
        let p=companies.map((company,i )=>{

            return <div className="company_name" key={i}> <span>{company.company_name}</span> </div>}
          )
        
        return (
            <div className="container"  style={{marginTop:'1%',marginBottom:'2%'}}>
                <h3 className="data_header">Customers</h3>
                
                    {
                        (companies.length>0) ? (
                            p
                        ) : (
                                /* companies.map(company =>
                                    <div className="col-6 company">
                                   
                                                                     <img src={(company.logo!=null&&company.logo!=undefined&&company.logo!='')?(company.logo):("https://image.flaticon.com/icons/svg/236/236832.svg")} ></img>
                                                                            <span className="company_name"> {company.company_name} </span>
                                  </div>
                                ) */
                               <>
                            <div className="undefined">
                                <p>
                                    Details not available
                                </p>
                            </div>
                            </>
                            )
                    }
               
            </div>
        )
    }
}

export default Customers
